<template>
  <div class="w-alert-container">
    <WorkInformation
      v-for="information in informations"
      :key="information.id"
      :closeable='information.closeable'
      :close="information.close"
      :close-text="information.closeText"
      @close_alert="closeAlert(information)"
    >
      <template slot="content-text">
        {{ information.message }}
      </template>
    </WorkInformation>
    <WorkWarning
      v-for="warning in warnings"
      :key="warning.id"
      :closeable='warning.closeable'
      :close="warning.close"
      :close-text="warning.closeText"
      @close_alert="closeAlert(warning)"
    >
      <template slot="content-text">
        {{ warning.message }}
      </template>
    </WorkWarning>
  </div>
</template>

<script>
import WorkAlertC, { WARNING_TYPE, INFORMATION_TYPE } from "@/components/global_components/alerts/WorkAlertC";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "WorkAlertContainer",
  components: {
    WorkWarning: () => import("@/components/alert_components/warning/WorkWarning"),
    WorkInformation: () => import("@/components/alert_components/info/WorkInformation")
  },
  props: {
    value: { type: Array },
  },
  computed: {
    internalValue() {
      return this.value.map((alert, index) => {
        return new WorkAlertC({ ...alert, id: index });
      });
    },
    informations() {
      return this.internalValue.filter((alert) => alert.type === INFORMATION_TYPE);
    },
    warnings() {
      return this.internalValue.filter((alert) => alert.type === WARNING_TYPE);
    },
  },
  methods: {
    closeAlert(alert) {
      const indexOfClosedAlert = this.internalValue.findIndex((_alert) => _alert.id === alert.id);
      const clonedValue = cloneDeep(this.value).filter((_alert, _index) => _index !== indexOfClosedAlert);
      this.$emit('input', clonedValue);
    }
  },
}
</script>
